import { RouteComponentProps } from '@reach/router'
import { Box } from 'reoil'
import Navigation from '../components/Navigation'
import { useThemeValue } from '../store/themeState'
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { useContentValue } from '../store/contentState'
import { MAX_WIDTH } from '../constants/media'
import TabNav from '../components/TabNav'

const AnnouncementPage: React.FC<RouteComponentProps> = () => {
  const theme = useThemeValue()
  const content = useContentValue()
  const announcementContent = content.find(item=>item.type==='notic')?.content

  return(
    <Box className='AnnouncementPage' stretch>
      <TabNav/>
      <Navigation title='招聘公告' />

      <Box className='content' stretch bg='white' p={3} py={4} css={css`
        p {
          color: ${theme.colors.text.body2};
          margin-bottom: 24px;
          line-height: 1.4;
        }

        img {
          box-shadow: ${theme.shadows.card};
          border-radius: 2px;
        }
      `}>
        <Box maxWidth={MAX_WIDTH} mx='auto'>
          <p dangerouslySetInnerHTML={{__html: announcementContent || ''}}>
          </p>
        </Box>
        {/* <Box maxWidth={800} stretch mx='auto'>
          <h3>南方报业2021校园招聘公告</h3>
          <p> 南方报业传媒集团以南方日报为龙头，与南方杂志、南方网、“南方+”客户端等形成“报、刊、网、端”龙头传播平台，带动全集团立体传播矩阵。集团目前拥有6种报纸、10种期刊、1家出版社、20个网站、7个手机客户端、370个社交媒体公众账号、3000块互动触控屏、10000平方米户外LED大屏幕，形成了“报、刊、网、端、微、屏”立体传播体系，覆盖用户超过2亿。 </p>
          <Box center mb={4}> <img style={{maxHeight: '50vmin'}} src="https://picsum.photos/seed/843/1000/1000" alt=""/> </Box>

          <h3>南方报业2021校园招聘公告</h3>
          <p> 南方报业传媒集团以南方日报为龙头，与南方杂志、南方网、“南方+”客户端等形成“报、刊、网、端”龙头传播平台，带动全集团立体传播矩阵。集团目前拥有6种报纸、10种期刊、1家出版社、20个网站、7个手机客户端、370个社交媒体公众账号、3000块互动触控屏、10000平方米户外LED大屏幕，形成了“报、刊、网、端、微、屏”立体传播体系，覆盖用户超过2亿。 </p>
          <Box center mb={4}> <img style={{maxHeight: '50vmin'}} src="https://picsum.photos/seed/844/300/300" alt=""/> </Box>
        </Box> */}

      </Box>
    </Box>
  )
}

export default AnnouncementPage
